import { render } from "./AdminDeviceList.vue?vue&type=template&id=211f8bcf&ts=true&lang=true"
import script from "./AdminDeviceList.vue?vue&type=script&lang=ts"
export * from "./AdminDeviceList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__